// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-H5k","index":"styles_index__3ArPf"};